// extracted by mini-css-extract-plugin
export default {"white":"#fff","notificationRed":"#ff4c68","primaryIcon":"#309df0","PostMenu__item--admin":"rf_a","PostMenu__item--moderator":"rf_b","PostMenu__item--author":"rf_c"};